<template>
  <v-btn
    icon
    variant="text"
    @click="toggleFavorite"
    :title="localIsFavorite ? 'Als Favorit entfernen' : 'Als Favorit markieren'"
    :disabled="loading"
  >
    <v-icon
      :icon="localIsFavorite ? 'mdi-star' : 'mdi-star-outline'"
      :style="{ color: localIsFavorite ? '#FFD700' : '#9E9E9E' }"
    />
  </v-btn>
</template>

<script>
export default {
  props: {
    favBtnSeatID: {
      type: Number,
      required: true
    },
    favBtnIsFavorite: {
      type: Boolean,
      required: true
    },
    favBtnFavoriteID: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      localIsFavorite: this.favBtnIsFavorite,
      localFavoriteID: this.favBtnFavoriteID,
      loading: false, // Sperrt den Button während API-Calls
    }
  },

  watch: {
    favBtnIsFavorite(newVal) {
      this.localIsFavorite = newVal
    },
    favBtnFavoriteID(newVal) {
      this.localFavoriteID = newVal
    }
  },

  emits: ['updateFavorite'],

  methods: {
    async toggleFavorite() {
      if (this.loading) return // mehrfach-Klick blocken
      this.loading = true

      const newStatus = !this.localIsFavorite
      this.localIsFavorite = newStatus

      if (newStatus) {
        await this.createFavorite()
      } else {
        await this.deleteFavorite()
      }

      this.$emit('updateFavorite')
      this.loading = false
    },

    async createFavorite() {
      try {
        const { data } = await this.$axios.post('/api/favorites/', { seat_id: this.favBtnSeatID })
        this.localFavoriteID = data.id
      } catch (error) {
        console.error('Keine Favoritenzuweisung möglich:', error)
        this.localIsFavorite = false // rollback
      }
    },

    async deleteFavorite() {
      if (!this.localFavoriteID) {
        console.warn('Kein Favorit zum Löschen vorhanden')
        return
      }
      try {
        await this.$axios.delete(`/api/favorites/${this.localFavoriteID}/`)
        this.localFavoriteID = null
      } catch (error) {
        console.error(`Löschen des Favoriteneintrags ${this.localFavoriteID} fehlgeschlagen:`, error)
        this.localIsFavorite = true // rollback
      }
    }
  }
}
</script>
